import { assertAddressBalanceTransfer } from './address-balance-transfer.strategy';
import { assertCoinObjectTransfer } from './coin-object-transfer.strategy';
import { assertMixedTransfer } from './mixed-transfer.strategy';
import type {
  TransferValidationContext,
  TransferValidationStrategy,
} from './transaction-validation';

export const selectTransferValidationStrategy = ({
  commands,
  inputs,
}: TransferValidationContext): TransferValidationStrategy => {
  if (!inputs.some((input) => input.$kind === 'FundsWithdrawal')) return assertCoinObjectTransfer;
  if (commands.some((command) => command.$kind === 'SplitCoins')) return assertMixedTransfer;
  return assertAddressBalanceTransfer;
};
